<template>
    <div>
        <b-row>
            <b-col sm="12" md="5">
                <b-alert show>
                    <span>
                        Tipo da Fase:
                        <strong>{{ faseContratoTemp.tipoFaseContrato }}</strong>
                        <br />Descrição:
                        <strong>{{ faseContratoTemp.descricao }}</strong>
                        <br />Vigência:
                        <strong>
                            {{
                                faseContratoTemp.dataInicioVigencia
                                    ? $moment(
                                          faseContratoTemp.dataInicioVigencia
                                      ).format('DD/MM/YYYY')
                                    : ''
                            }}
                            a
                            {{
                                faseContratoTemp.dataFimVigencia
                                    ? $moment(
                                          faseContratoTemp.dataFimVigencia
                                      ).format('DD/MM/YYYY')
                                    : ''
                            }}
                        </strong>
                        <br />Valor:
                        <strong>{{ faseContratoTemp.valor | currency }}</strong>
                        <br />Sem Registro:
                        <strong>{{
                            faseContratoTemp.disponivel | currency
                        }}</strong>
                    </span>
                </b-alert>
                <div>
                    <btn-inserir-detalhe-entrega
                        :fase="faseContratoTemp"
                        :apostilamento="apostilamento"
                        :contrato="contrato"
                        v-if="mostrarBtnInserirDetalheEntrega"
                        @obterDetalhesFaseAtualizados="obterFaseAtualizada()"
                        @obterComprometimentosAtualizados="
                            $emit('obterComprometimentosAtualizados')
                        "
                    ></btn-inserir-detalhe-entrega>
                    <btn-inserir-detalhe-parcela-fixa
                        :fase="faseContratoTemp"
                        :apostilamento="apostilamento"
                        :contrato="contrato"
                        v-if="mostrarBtnInserirDetalheParcelaFixa"
                        @obterDetalhesFaseAtualizados="obterFaseAtualizada()"
                        @obterComprometimentosAtualizados="
                            $emit('obterComprometimentosAtualizados')
                        "
                    ></btn-inserir-detalhe-parcela-fixa>
                    <btn-inserir-detalhes-fase-em-lote
                        :fase="faseContratoTemp"
                        :apostilamento="apostilamento"
                        :contrato="contrato"
                        v-if="mostrarBtnInserirDetalheParcelaFixaEmLote"
                        @obterDetalhesFaseAtualizados="obterFaseAtualizada()"
                        @obterComprometimentosAtualizados="
                            $emit('obterComprometimentosAtualizados')
                        "
                    ></btn-inserir-detalhes-fase-em-lote>
                    <btn-excluir-detalhes-fase-em-lote
                        :fase="faseContratoTemp"
                        :apostilamento="apostilamento"
                        :contrato="contrato"
                        :detalhesSelecionados="detalhesSelecionados"
                        v-if="mostrarBtnExcluirDetalhesEmLote"
                        @obterDetalhesFaseAtualizados="obterFaseAtualizada()"
                        @limparDetalhesSelecionados="marcarDesmarcarTodas()"
                        @obterComprometimentosAtualizados="
                            $emit('obterComprometimentosAtualizados')
                        "
                    ></btn-excluir-detalhes-fase-em-lote>
                    <btn-atualizar-valores-em-lote-detalhes-fase
                        :fase="faseContratoTemp"
                        :apostilamento="apostilamento"
                        :contrato="contrato"
                        :detalhesSelecionados="detalhesSelecionados"
                        :valorMaximoParcela="valorMaximoParcela"
                        v-if="mostrarBtnAtualizarEmLoteDetalhes"
                        @obterDetalhesFaseAtualizados="obterFaseAtualizada()"
                        @limparDetalhesSelecionados="marcarDesmarcarTodas()"
                        @obterComprometimentosAtualizados="
                            $emit('obterComprometimentosAtualizados')
                        "
                    ></btn-atualizar-valores-em-lote-detalhes-fase>
                </div>
            </b-col>
            <b-col sm="12" md="7">
                <app-tabela
                    idTabela="tblDetalhesFaseContrato"
                    :itens="detalhesFaseContrato"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                    :bordered="false"
                    :small="false"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button variant="danger" @click.stop="voltar()">
                                <span>
                                    <i class="fa fa-history mr-2"></i> Retornar
                                    para Fases
                                </span>
                            </b-button>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                        <btn-atualizar-detalhe-entrega
                            :fase="faseContratoTemp"
                            :contrato="contrato"
                            :apostilamento="apostilamento"
                            :detalhe="data"
                            v-if="mostrarBtnAtualizarDetalheEntrega(data)"
                            @obterDetalhesFaseAtualizados="
                                obterFaseAtualizada()
                            "
                            @obterComprometimentosAtualizados="
                                $emit('obterComprometimentosAtualizados')
                            "
                        ></btn-atualizar-detalhe-entrega>
                        <btn-atualizar-detalhe-parcela-fixa
                            :fase="faseContratoTemp"
                            :apostilamento="apostilamento"
                            :contrato="contrato"
                            :detalhe="data"
                            v-if="mostrarBtnAtualizarDetalheParcelaFixa(data)"
                            @obterDetalhesFaseAtualizados="
                                obterFaseAtualizada()
                            "
                            @obterComprometimentosAtualizados="
                                $emit('obterComprometimentosAtualizados')
                            "
                        ></btn-atualizar-detalhe-parcela-fixa>
                        <btn-excluir-detalhe-fase
                            :fase="faseContratoTemp"
                            :apostilamento="apostilamento"
                            :contrato="contrato"
                            :detalheFase="data"
                            v-if="mostrarBtnExcluirDetalheFase(data)"
                            @obterDetalhesFaseAtualizados="
                                obterFaseAtualizada()
                            "
                            @obterComprometimentosAtualizados="
                                $emit('obterComprometimentosAtualizados')
                            "
                        ></btn-excluir-detalhe-fase>
                    </template>
                    <template slot="valor" slot-scope="data">
                        <p class="text-right m-0">
                            {{ data.valor | currency }}
                        </p>
                    </template>
                    <template slot="comprometido" slot-scope="data">
                        <app-status
                            :status="data.comprometido ? 'SIM' : 'NÃO'"
                        ></app-status>
                    </template>
                    <template slot="competencia" slot-scope="data">{{
                        data.mesPrevisto
                            ? $moment(data.mesPrevisto).format('MM/YYYY')
                            : ''
                    }}</template>
                    <template slot="mesPrevisto" slot-scope="data">{{
                        data.mesPrevisto
                            ? $moment(data.mesPrevisto).format('MM/YYYY')
                            : ''
                    }}</template>
                    <template slot="HEAD_detalheSelecao">
                        <i
                            class="fa fa-check-square fa-lg text-muted icon-button p-0 m-0"
                            title="Marcar/Desmarcar todos"
                            @click.stop="marcarDesmarcarTodas()"
                        ></i>
                    </template>
                    <template slot="detalheSelecao" slot-scope="data">
                        <b-form-checkbox
                            :value="data.detalheFaseContratoId"
                            v-model="detalhesSelecionados"
                            v-if="mostrarBtnAtualizarDetalheParcelaFixa(data)"
                        ></b-form-checkbox>
                    </template>
                </app-tabela>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ContratosServicos from './../ContratosServicos'
import BtnAtualizarDetalheEntrega from './BtnAtualizarDetalheEntrega'
import BtnAtualizarDetalheParcelaFixa from './BtnAtualizarDetalheParcelaFixa'
import BtnInserirDetalheEntrega from './BtnInserirDetalheEntrega'
import BtnInserirDetalheParcelaFixa from './BtnInserirDetalheParcelaFixa'
import BtnExcluirDetalheFase from './BtnExcluirDetalheFase'
import BtnAtualizarValoresEmLoteDetalhesFase from './BtnAtualizarValoresEmLoteDetalhesFase'
import { situacaoContrato } from '../SituacaoContrato'
import BtnInserirDetalhesFaseEmLote from './BtnInserirDetalhesFaseEmLote'
import BtnExcluirDetalhesFaseEmLote from './BtnExcluirDetalhesFaseEmLote'

export default {
    components: {
        BtnAtualizarDetalheEntrega,
        BtnAtualizarDetalheParcelaFixa,
        BtnInserirDetalheEntrega,
        BtnInserirDetalheParcelaFixa,
        BtnExcluirDetalheFase,
        BtnAtualizarValoresEmLoteDetalhesFase,
        BtnInserirDetalhesFaseEmLote,
        BtnExcluirDetalhesFaseEmLote
    },

    props: {
        faseContrato: {
            type: Object,
            default: () => {}
        },

        apostilamento: {
            type: Boolean,
            default: () => false
        },

        contratoElaboracao: {
            type: Boolean,
            default: () => false
        },

        contrato: {
            type: Object,
            default: () => ({})
        },

        aditivoContratoIniciado: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            detalhesFaseContrato: [],
            detalhesSelecionados: [],
            campos: [],
            faseContratoTemp: {},
            camposParcelaFixa: [
                {
                    key: 'detalheSelecao',
                    label: '',
                    customHead: true
                },
                {
                    key: 'competencia',
                    label: 'Competência',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'vencimento',
                    label: 'Vencimento',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'comprometido',
                    label: 'Comprometido',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            camposEntrega: [
                {
                    key: 'descricao',
                    label: 'Produto',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'mesPrevisto',
                    label: 'Mês Previsto',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'comprometido',
                    label: 'Comprometido',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },
    methods: {
        obterFase() {
            this.$store.dispatch('addRequest')
            ContratosServicos.obterFasePorId(
                this.$route.params.contratoId,
                this.faseContrato.faseContratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.detalhesFaseContrato =
                            response.data.detalhesFaseContrato
                        this.faseContratoTemp.disponivel =
                            response.data.disponivel
                        this.faseContratoTemp.temComprometimento =
                            response.data.temComprometimento
                    } else {
                        this.$toast.error(response.errors, 'ERROR', this.error)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterFaseAtualizada() {
            this.obterFase()
            this.$emit('obterFasesAtualizadas')
        },

        voltar() {
            this.$emit('fecharDetalhesFaseContrato')
        },

        mostrarBtnAtualizarDetalheEntrega(detalhe) {
            return (
                (this.apostilamento ||
                    this.contratoElaboracao ||
                    this.aditivoContratoIniciado) &&
                this.faseContrato.tipoFaseContratoId == 2 &&
                !detalhe.comprometido &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnAtualizarDetalheParcelaFixa(detalhe) {
            return (
                (this.apostilamento ||
                    this.contratoElaboracao ||
                    this.aditivoContratoIniciado) &&
                this.faseContrato.tipoFaseContratoId == 1 &&
                !detalhe.comprometido &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnExcluirDetalheFase(detalhe) {
            return (
                (this.apostilamento ||
                    this.contratoElaboracao ||
                    this.aditivoContratoIniciado) &&
                !detalhe.comprometido &&
                this.controleHistoricoAditivos()
            )
        },

        marcarDesmarcarTodas() {
            if (this.detalhesSelecionados.length > 0) {
                this.detalhesSelecionados = []
            } else {
                this.detalhesSelecionados = this.detalhesFaseContrato
                    .filter(detalhe => {
                        return !detalhe.comprometido
                    })
                    .map(item => {
                        return item.detalheFaseContratoId
                    })
            }
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        }
    },

    created() {
        if (this.faseContrato.tipoFaseContratoId === 1) {
            this.campos = this.camposParcelaFixa
        } else if (this.faseContrato.tipoFaseContratoId === 2) {
            this.campos = this.camposEntrega
        }
        this.faseContratoTemp = this.faseContrato
        this.obterFase()
    },

    computed: {
        mostrarBtnInserirDetalheEntrega() {
            return (
                (this.apostilamento ||
                    this.contratoElaboracao ||
                    this.aditivoContratoIniciado) &&
                this.faseContrato.tipoFaseContratoId == 2 &&
                this.faseContratoTemp.disponivel > 0 &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnAtualizarEmLoteDetalhes() {
            return (
                (this.apostilamento ||
                    this.contratoElaboracao ||
                    this.aditivoContratoIniciado) &&
                this.faseContrato.tipoFaseContratoId === 1 &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnExcluirDetalhesEmLote() {
            return (
                (this.apostilamento ||
                    this.contratoElaboracao ||
                    this.aditivoContratoIniciado) &&
                this.faseContrato.tipoFaseContratoId === 1 &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnInserirDetalheParcelaFixa() {
            return (
                (this.apostilamento ||
                    this.contratoElaboracao ||
                    this.aditivoContratoIniciado) &&
                this.faseContrato.tipoFaseContratoId == 1 &&
                this.faseContratoTemp.disponivel > 0 &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnInserirDetalheParcelaFixaEmLote() {
            return (
                (this.apostilamento ||
                    this.contratoElaboracao ||
                    this.aditivoContratoIniciado) &&
                this.faseContrato.tipoFaseContratoId == 1 &&
                this.faseContratoTemp.disponivel ==
                    this.faseContratoTemp.valor &&
                this.controleHistoricoAditivos()
            )
        },

        valorMaximoParcela() {
            if (this.detalhesSelecionados.length > 0) {
                let detalhesSelecionadosTemp = this.detalhesFaseContrato.filter(
                    det1 => {
                        return this.detalhesSelecionados.some(det2 => {
                            return det1.detalheFaseContratoId === det2
                        })
                    }
                )
                let valorParcelasSelecionadas = detalhesSelecionadosTemp.reduce(
                    (a, b) => a + b.valor,
                    0
                )
                let valorDisponivel =
                    valorParcelasSelecionadas + this.faseContrato.disponivel
                let valorParcela =
                    valorDisponivel / detalhesSelecionadosTemp.length
                return valorParcela
            }
            return 0
        }
    },

    watch: {}
}
</script>
